module.exports = __webpack_public_path__ + "static/media/jobFairBg.af670bda.jpg";